import { ContactSupportForm } from '@adthlete/shared-frontend'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { MainLayout } from '@/components/layout/MainLayout'
import { Link } from 'react-router-dom'

const Help = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pb-4 max-w-2xl">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-foreground mb-2">Help & Support</h1>
            <p className="text-gray-600">Get in touch with our team and we'll be happy to help.</p>
          </div>

          <Card variant="dark">
            <CardHeader>
              <CardTitle dark>Contact Support</CardTitle>
              <CardDescription dark>
                Send us a message and we'll get back to you within one business day.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ContactSupportForm variant="dark" />
            </CardContent>
          </Card>

          <Card variant="dark" className="mt-6">
            <CardHeader>
              <CardTitle dark>Legal</CardTitle>
            </CardHeader>
            <CardContent>
              <Link to="/terms" className="text-[#3F7A0A] hover:text-[#3F7A0A] underline">
                Terms of Use & Privacy Policy
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </MainLayout>
  )
}

export default Help
